export function getSeoFallbackImageUrl(): string {
  if (typeof window === "undefined") return "/static/favicon.png";
  return new URL("/static/favicon.png", window.location.origin).toString();
}
